import APIService from '@/services/api-service'
const resource = '/vehicle'
const subResource = 'list'

class VehicleListService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public saveVehicles (data: any) {
    return this.connector.post(`${resource}/${subResource}/save`, data)
  }

  public getVehicles (companyId: number) {
    return this.connector.get(`${resource}/${subResource}/${companyId}/all`)
  }

  public deleteVehicle (id: number) {
    return this.connector.delete(`${resource}/${subResource}/${id}/delete`)
  }
}

export default new VehicleListService()
